export const permissionOptions = {
  full: 'Broad Content License',
  full_limited_time:'Limited Time Broad Content License',
  limited: 'Custom Content License',
  none: 'No Content License',
};

export const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'bmp', 'webp', 'heif', 'svg', 'eps', 'ico'];
